/*! For license information please see sections.gmv-pdp-rhude.js.LICENSE.txt */
(() => {
	function t(e) {
		return t = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
			return typeof t
		} : function(t) {
			return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
		}, t(e)
	}

	function e() {
		var t, i, r = "function" == typeof Symbol ? Symbol : {},
			o = r.iterator || "@@iterator",
			a = r.toStringTag || "@@toStringTag";

		function u(e, r, o, a) {
			var u = r && r.prototype instanceof l ? r : l,
				d = Object.create(u.prototype);
			return n(d, "_invoke", function(e, n, r) {
				var o, a, u, l = 0,
					d = r || [],
					c = !1,
					h = {
						p: 0,
						n: 0,
						v: t,
						a: y,
						f: y.bind(t, 4),
						d: function(e, n) {
							return o = e, a = 0, u = t, h.n = n, s
						}
					};

				function y(e, n) {
					for (a = e, u = n, i = 0; !c && l && !r && i < d.length; i++) {
						var r, o = d[i],
							y = h.p,
							f = o[2];
						e > 3 ? (r = f === n) && (u = o[(a = o[4]) ? 5 : (a = 3, 3)], o[4] = o[5] = t) : o[0] <= y && ((r = e < 2 && y < o[1]) ? (a = 0, h.v = n, h.n = o[1]) : y < f && (r = e < 3 || o[0] > n || n > f) && (o[4] = e, o[5] = n, h.n = f, a = 0))
					}
					if (r || e > 1) return s;
					throw c = !0, n
				}
				return function(r, d, f) {
					if (l > 1) throw TypeError("Generator is already running");
					for (c && 1 === d && y(d, f), a = d, u = f;
						(i = a < 2 ? t : u) || !c;) {
						o || (a ? a < 3 ? (a > 1 && (h.n = -1), y(a, u)) : h.n = u : h.v = u);
						try {
							if (l = 2, o) {
								if (a || (r = "next"), i = o[r]) {
									if (!(i = i.call(o, u))) throw TypeError("iterator result is not an object");
									if (!i.done) return i;
									u = i.value, a < 2 && (a = 0)
								} else 1 === a && (i = o.return) && i.call(o), a < 2 && (u = TypeError("The iterator does not provide a '" + r + "' method"), a = 1);
								o = t
							} else if ((i = (c = h.n < 0) ? u : e.call(n, h)) !== s) break
						} catch (e) {
							o = t, a = 1, u = e
						} finally {
							l = 1
						}
					}
					return {
						value: i,
						done: c
					}
				}
			}(e, o, a), !0), d
		}
		var s = {};

		function l() {}

		function d() {}

		function c() {}
		i = Object.getPrototypeOf;
		var h = [][o] ? i(i([][o]())) : (n(i = {}, o, function() {
				return this
			}), i),
			y = c.prototype = l.prototype = Object.create(h);

		function f(t) {
			return Object.setPrototypeOf ? Object.setPrototypeOf(t, c) : (t.__proto__ = c, n(t, a, "GeneratorFunction")), t.prototype = Object.create(y), t
		}
		return d.prototype = c, n(y, "constructor", c), n(c, "constructor", d), d.displayName = "GeneratorFunction", n(c, a, "GeneratorFunction"), n(y), n(y, a, "Generator"), n(y, o, function() {
			return this
		}), n(y, "toString", function() {
			return "[object Generator]"
		}), (e = function() {
			return {
				w: u,
				m: f
			}
		})()
	}

	function n(t, e, i, r) {
		var o = Object.defineProperty;
		try {
			o({}, "", {})
		} catch (t) {
			o = 0
		}
		n = function(t, e, i, r) {
			if (e) o ? o(t, e, {
				value: i,
				enumerable: !r,
				configurable: !r,
				writable: !r
			}) : t[e] = i;
			else {
				var a = function(e, i) {
					n(t, e, function(t) {
						return this._invoke(e, i, t)
					})
				};
				a("next", 0), a("throw", 1), a("return", 2)
			}
		}, n(t, e, i, r)
	}

	function i(t, e) {
		var n = "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
		if (!n) {
			if (Array.isArray(t) || (n = function(t, e) {
					if (t) {
						if ("string" == typeof t) return r(t, e);
						var n = {}.toString.call(t).slice(8, -1);
						return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? r(t, e) : void 0
					}
				}(t)) || e && t && "number" == typeof t.length) {
				n && (t = n);
				var i = 0,
					o = function() {};
				return {
					s: o,
					n: function() {
						return i >= t.length ? {
							done: !0
						} : {
							done: !1,
							value: t[i++]
						}
					},
					e: function(t) {
						throw t
					},
					f: o
				}
			}
			throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
		}
		var a, u = !0,
			s = !1;
		return {
			s: function() {
				n = n.call(t)
			},
			n: function() {
				var t = n.next();
				return u = t.done, t
			},
			e: function(t) {
				s = !0, a = t
			},
			f: function() {
				try {
					u || null == n.return || n.return()
				} finally {
					if (s) throw a
				}
			}
		}
	}

	function r(t, e) {
		(null == e || e > t.length) && (e = t.length);
		for (var n = 0, i = Array(e); n < e; n++) i[n] = t[n];
		return i
	}

	function o(t, e, n, i, r, o, a) {
		try {
			var u = t[o](a),
				s = u.value
		} catch (t) {
			return void n(t)
		}
		u.done ? e(s) : Promise.resolve(s).then(i, r)
	}

	function a(t) {
		return function() {
			var e = this,
				n = arguments;
			return new Promise(function(i, r) {
				var a = t.apply(e, n);

				function u(t) {
					o(a, i, r, u, s, "next", t)
				}

				function s(t) {
					o(a, i, r, u, s, "throw", t)
				}
				u(void 0)
			})
		}
	}

	function u(t, e) {
		for (var n = 0; n < e.length; n++) {
			var i = e[n];
			i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, s(i.key), i)
		}
	}

	function s(e) {
		var n = function(e, n) {
			if ("object" != t(e) || !e) return e;
			var i = e[Symbol.toPrimitive];
			if (void 0 !== i) {
				var r = i.call(e, n || "default");
				if ("object" != t(r)) return r;
				throw new TypeError("@@toPrimitive must return a primitive value.")
			}
			return ("string" === n ? String : Number)(e)
		}(e, "string");
		return "symbol" == t(n) ? n : n + ""
	}! function() {
		"use strict";
		if (!window.GMV_PDP_Rhude) {
			var t = function() {
				return t = function t(e) {
					var n, i, r;
					! function(t, e) {
						if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
					}(this, t), this.container = e, this.productId = e.dataset.productId, this.sectionId = e.dataset.sectionId, this.isForcedSoldOut = e.dataset.forcedSoldOut === "true";
					var o = document.querySelector("[data-product-json]");
					this.variants = o ? JSON.parse(o.textContent) : [];
					var a = document.querySelector("[data-inventory-json]");
					var inventoryData = a ? JSON.parse(a.textContent) : {};
					this.inventoryMap = inventoryData.inventory || inventoryData;
					this.lowStockThreshold = inventoryData.lowStockThreshold || parseInt(e.dataset.lowStockThreshold) || 3, this.form = e.querySelector("[data-product-form]"), this.variantIdInput = e.querySelector("[data-variant-id]"), this.addToCartButton = e.querySelector("[data-add-to-cart]"), this.buttonText = null === (n = this.addToCartButton) || void 0 === n ? void 0 : n.querySelector("[data-button-text]"), this.textAddToCart = (null === (i = this.addToCartButton) || void 0 === i ? void 0 : i.dataset.textAddToCart) || "ADD TO CART", this.textSoldOut = (null === (r = this.addToCartButton) || void 0 === r ? void 0 : r.dataset.textSoldOut) || "SOLD OUT", this.priceContainer = e.querySelector("[data-price-container]"), this.priceElement = e.querySelector("[data-price]"), this.variantOptions = e.querySelectorAll("[data-variant-option]"), this.quantityInput = e.querySelector("[data-quantity-input]"), this.quantityMinusBtn = e.querySelector("[data-quantity-minus]"), this.quantityPlusBtn = e.querySelector("[data-quantity-plus]"), this.notifyMeContainer = e.querySelector("[data-notify-me]"), this.notifyEmailInput = e.querySelector("[data-notify-email]"), this.notifySubmitBtn = e.querySelector("[data-notify-submit]"), this.notifySuccess = e.querySelector("[data-notify-success]"), this.zoomTriggers = e.querySelectorAll("[data-zoom-trigger]"), this.zoomOverlay = e.querySelector("[data-zoom-overlay]"), this.zoomClose = e.querySelector("[data-zoom-close]"), this.zoomImages = e.querySelectorAll("[data-zoom-image]"), this.accordionTriggers = e.querySelectorAll("[data-accordion-trigger]"), this.gallerySlider = e.querySelector("[data-gallery-slider]"), this.galleryPrevBtn = e.querySelector("[data-gallery-prev]"), this.galleryNextBtn = e.querySelector("[data-gallery-next]"), this.galleryCurrentSlide = e.querySelector("[data-current-slide]"), this.currentSlideIndex = 0, this.sizeGuideButtons = e.querySelectorAll("[data-open-size-guide]"), this.sizeGuideOverlay = e.querySelector("#size-guide-overlay-rhude"), this.sizeGuidePopup = e.querySelector("#size-guide-popup-rhude"), this.sizeGuideClose = e.querySelector("[data-close-size-guide]"), this.lowStockIndicator = e.querySelector("[data-low-stock-indicator]"), this.init()
				}, n = [{
					key: "init",
					value: function() {
						this.setupVariants(), this.setupQuantity(), this.setupForm(), this.setupZoom(), this.setupNotifyMe(), this.setupMobileGalleryNav(), this.setupSizeGuide(), this.setInitialVariant(), this.updateQuantityButtons()
					}
				}, {
					key: "setupVariants",
					value: function() {
						var t = this;
						this.variantOptions.forEach(function(e) {
							e.addEventListener("change", function() {
								return t.handleVariantChange()
							})
						})
					}
				}, {
					key: "handleVariantChange",
					value: function() {
						var t = this.getSelectedOptions(),
							e = this.getVariantFromOptions(t);
						e && this.updateVariant(e)
					}
				}, {
					key: "getSelectedOptions",
					value: function() {
						var t = {};
						return this.variantOptions.forEach(function(e) {
							if (e.checked) {
								var n = e.dataset.optionPosition;
								t["option".concat(n)] = e.value
							}
						}), t
					}
				}, {
					key: "getVariantFromOptions",
					value: function(t) {
						return this.variants.find(function(e) {
							return Object.keys(t).every(function(n) {
								return e[n] === t[n]
							})
						})
					}
				}, {
					key: "updateVariant",
					value: function(t) {
						var isAvailable = t.available && !this.isForcedSoldOut;
						this.variantIdInput && (this.variantIdInput.value = t.id, this.variantIdInput.disabled = !1), this.updatePrice(t), this.updateAddToCartButton(t), this.updateQuantityMax(t), this.updateLowStockIndicator(t), this.updateURL(t), this.toggleNotifyMe(!isAvailable)
					}
				}, {
					key: "updatePrice",
					value: function(t) {
						var e;
						if (this.priceElement) {
							// Get promo data from JSON script
							var promoScript = document.querySelector('[data-promo-json]');
							var promoActive = false;
							var promoPercentage = 0;
							if (promoScript) {
								try {
									var promoData = JSON.parse(promoScript.textContent);
									promoActive = promoData.promo_active === true;
									promoPercentage = promoData.promo_percentage || 0;
								} catch(err) {}
							}
							
							var i = null === (e = this.priceContainer) || void 0 === e ? void 0 : e.querySelector(".gmv-pdp-rhude__price-compare");
							var badge = null === (e = this.priceContainer) || void 0 === e ? void 0 : e.querySelector(".discount-percentage");
							
							// Check for manual discount (compare_at_price)
							if (t.compare_at_price && t.compare_at_price > t.price) {
								// Manual discount - show compare_at_price
								this.priceElement.textContent = this.formatMoney(t.price);
								if (i) {
									i.textContent = this.formatMoney(t.compare_at_price);
									i.style.display = "";
								}
								if (badge) {
									var discAmt = t.compare_at_price - t.price;
									var discPerc = Math.round((discAmt * 100.0) / t.compare_at_price);
									badge.textContent = discPerc + "% OFF";
									badge.style.display = "";
								}
							} else if (promoActive && promoPercentage > 0) {
								// Promo discount - calculate discounted price
								var origPrice = t.price;
								var discAmount = origPrice * (promoPercentage / 100.0);
								var discPrice = origPrice - discAmount;
								
								this.priceElement.textContent = this.formatMoney(discPrice);
								if (i) {
									i.innerHTML = "<s>" + this.formatMoney(origPrice) + "</s>";
									i.style.display = "";
								}
								if (badge) {
									badge.textContent = promoPercentage + "% OFF";
									badge.style.display = "";
								}
							} else {
								// No discount
								this.priceElement.textContent = this.formatMoney(t.price);
								if (i) i.style.display = "none";
							}
						}
					}
				}, {
					key: "updateAddToCartButton",
					value: function(t) {
						var isAvailable = t.available && !this.isForcedSoldOut;
						this.addToCartButton && this.buttonText && (isAvailable ? (this.addToCartButton.disabled = !1, this.buttonText.textContent = this.textAddToCart) : (this.addToCartButton.disabled = !0, this.buttonText.textContent = this.textSoldOut), this.updateQuantityControlsState(isAvailable))
					}
				}, {
					key: "updateQuantityControlsState",
					value: function(t) {
						this.quantityMinusBtn && (this.quantityMinusBtn.disabled = !t), this.quantityPlusBtn && (this.quantityPlusBtn.disabled = !t), this.quantityInput && (this.quantityInput.disabled = !t)
					}
				}, {
					key: "updateURL",
					value: function(t) {
						if (t && window.history.replaceState) {
							var e = new URL(window.location.href);
							e.searchParams.set("variant", t.id), window.history.replaceState({}, "", e.toString())
						}
					}
				}, {
					key: "setInitialVariant",
					value: function() {
						var t = new URLSearchParams(window.location.search).get("variant");
						if (t) {
							var e = this.variants.find(function(e) {
								return e.id == t
							});
							e && (this.selectVariantOptions(e), this.updateVariant(e))
						}
					}
				}, {
					key: "selectVariantOptions",
					value: function(t) {
						this.variantOptions.forEach(function(e) {
							var n = e.dataset.optionPosition,
								i = "option".concat(n);
							t[i] === e.value && (e.checked = !0)
						})
					}
				}, {
					key: "setupQuantity",
					value: function() {
						var t, e, n = this;
						if (!this.quantityInput) return;
						if (this.quantityMinusBtn && this.quantityMinusBtn.dataset.rhudeQtyBound === "1") return;
						this.quantityMinusBtn && (this.quantityMinusBtn.dataset.rhudeQtyBound = "1");
						this.quantityPlusBtn && (this.quantityPlusBtn.dataset.rhudeQtyBound = "1");
						null === (t = this.quantityMinusBtn) || void 0 === t || t.addEventListener("click", function(t) {
							if (n.quantityMinusBtn.disabled) t.preventDefault();
							else {
								var e = parseInt(n.quantityInput.value) || 1;
								e > 1 && (n.quantityInput.value = e - 1), n.updateQuantityButtons()
							}
						}), null === (e = this.quantityPlusBtn) || void 0 === e || e.addEventListener("click", function(t) {
							if (n.quantityPlusBtn.disabled) t.preventDefault();
							else {
								var e = parseInt(n.quantityInput.value) || 1;
								e < (parseInt(n.quantityInput.max) || 999) ? n.quantityInput.value = e + 1 : n.showMaxQuantityWarning(), n.updateQuantityButtons()
							}
						})
					}
				}, {
					key: "updateQuantityButtons",
					value: function() {
						if (this.quantityInput && !this.quantityInput.disabled) {
							var t = parseInt(this.quantityInput.value) || 1,
								e = parseInt(this.quantityInput.max) || 999;
							this.quantityMinusBtn && (this.quantityMinusBtn.disabled = t <= 1), this.quantityPlusBtn && (this.quantityPlusBtn.disabled = t >= e)
						}
					}
				}, {
					key: "showMaxQuantityWarning",
					value: function() {
						var t = this,
							e = parseInt(this.quantityInput.max) || 0;
						if (this.buttonText) {
							var n = this.buttonText.textContent;
							this.buttonText.textContent = "MAX ".concat(e, " IN STOCK"), setTimeout(function() {
								t.buttonText.textContent = n
							}, 2e3)
						}
					}
				}, {
					key: "updateQuantityMax",
					value: function(t) {
						if (this.quantityInput) {
							var e = 999;
							if (this.isForcedSoldOut) {
								e = 0;
							} else if (this.inventoryMap && this.inventoryMap[t.id]) {
								var n = this.inventoryMap[t.id];
								n > 0 ? e = n : 0 !== n || t.available ? 0 === n && t.available && (e = 999) : e = 0
							}
							this.quantityInput.max = e, this.quantityInput.value = 1, this.updateQuantityButtons()
						}
					}
				}, 	{
					key: "updateLowStockIndicator",
					value: function(t) {
						if (this.lowStockIndicator) {
							var qty = 0;

							// Ambil stok dari inventoryMap (JSON di bawah section)
							if (this.inventoryMap && this.inventoryMap[t.id] !== void 0) {
							qty = this.inventoryMap[t.id];
							} else if (typeof t.inventory_quantity === "number") {
							qty = t.inventory_quantity;
							}

							// DEBUG: lihat kondisi stok di console
							console.log("[GMV Rhude] Variant ID:", t.id, "Title:", t.title, "Qty:", qty, "Available:", t.available, "LowStockThreshold:", this.lowStockThreshold);

							// Logic tampil / sembunyi tulisan "Low Stock"
							// Threshold diambil dari metafield custom.low_stock_threshold, default 3
							var threshold = this.lowStockThreshold || 3;
							if (qty > 0 && qty < threshold) {
							this.lowStockIndicator.style.display = "inline";
							} else {
							this.lowStockIndicator.style.display = "none";
							}
						}
					}
				}, {
					key: "setupForm",
					value: function() {
						var t = this;
						this.form && this.form.addEventListener("submit", function(e) {
							e.preventDefault(), t.handleAddToCart()
						})
					}
				}, {
					key: "handleAddToCart",
					value: (s = a(e().m(function t() {
						var n, r, o, a, u, s, l, d, c, h, y, f, v, p, m;
						return e().w(function(t) {
							for (;;) switch (t.n) {
								case 0:
									if (this.variantIdInput && !this.variantIdInput.disabled) {
										t.n = 1;
										break
									}
									return t.a(2);
								case 1:
									if (n = this.getCurrentVariant()) {
										t.n = 2;
										break
									}
									return t.a(2);
								case 2:
									this.variantIdInput.value = n.id, this.setButtonLoading(!0), t.p = 3, a = document.querySelector("cart-drawer"), u = new FormData(this.form), s = [], l = i(u.keys());
									try {
										for (l.s(); !(d = l.n()).done;)((c = d.value).startsWith("options[") || "product-id" === c || "section-id" === c) && s.push(c)
									} catch (t) {
										l.e(t)
									} finally {
										l.f()
									}
									if (s.forEach(function(t) {
											return u.delete(t)
										}), u.get("id")) {
										t.n = 4;
										break
									}
									return this.setButtonLoading(!1), t.a(2);
								case 4:
									return a && (h = ["gmv-cart-drawer"], u.append("sections", h.join(",")), u.append("sections_url", window.location.pathname), a.setActiveElement && a.setActiveElement(document.activeElement)), y = null !== (r = window.Shopify) && void 0 !== r && null !== (r = r.routes) && void 0 !== r && r.root ? window.Shopify.routes.root + "cart/add.js" : null !== (o = window.routes) && void 0 !== o && o.cart_add_url ? window.routes.cart_add_url : "/cart/add.js", t.n = 5, fetch(y, {
										method: "POST",
										headers: {
											"X-Requested-With": "XMLHttpRequest"
										},
										body: u
									});
								case 5:
									if ((f = t.v).ok) {
										t.n = 10;
										break
									}
									return t.p = 6, t.n = 7, f.json();
								case 7:
									v = t.v, t.n = 9;
									break;
								case 8:
									t.p = 8, t.v, v = {
										message: f.statusText
									};
								case 9:
									throw new Error(v.description || v.message || "Failed to add to cart");
								case 10:
									return t.n = 11, f.json();
								case 11:
									if (!(p = t.v).status) {
										t.n = 12;
										break
									}
									throw new Error(p.description || "Failed to add to cart");
								case 12:
									document.dispatchEvent(new CustomEvent("cart:item-added", {
										detail: p,
										bubbles: !0
									})), document.dispatchEvent(new CustomEvent("cart:updated", {
										detail: p,
										bubbles: !0
									})), a && "function" == typeof a.renderContents ? a.renderContents(p) : window.location.href = window.routes.cart_url || "/cart", t.n = 14;
									break;
								case 13:
									t.p = 13, m = t.v, this.showAddToCartError(m.message);
								case 14:
									return t.p = 14, this.setButtonLoading(!1), t.f(14);
								case 15:
									return t.a(2)
							}
						}, t, this, [
							[6, 8],
							[3, 13, 14, 15]
						])
					})), function() {
						return s.apply(this, arguments)
					})
				}, {
					key: "setButtonLoading",
					value: function(t) {
						if (this.addToCartButton && this.buttonText)
							if (t) this.addToCartButton.disabled = !0, this.buttonText.textContent = "ADDING...";
							else {
								var e = this.getCurrentVariant();
								this.updateAddToCartButton(e || {
									available: !1
								})
							}
					}
				}, {
					key: "getCurrentVariant",
					value: function() {
						var t = this.getSelectedOptions();
						return this.getVariantFromOptions(t)
					}
				}, {
					key: "showAddToCartSuccess",
					value: function() {
						var t = this;
						if (this.buttonText) {
							var e = this.buttonText.textContent;
							this.buttonText.textContent = "ADDED!", setTimeout(function() {
								t.buttonText.textContent = e
							}, 2e3)
						}
					}
				}, {
					key: "showAddToCartError",
					value: function(t) {
						var e = this;
						if (this.buttonText) {
							var n = this.buttonText.textContent;
							this.buttonText.textContent = "ERROR", setTimeout(function() {
								e.buttonText.textContent = n
							}, 2e3)
						}
					}
				}, {
					key: "setupNotifyMe",
					value: function() {
						var t = this;
						this.notifySubmitBtn && this.notifySubmitBtn.addEventListener("click", function() {
							t.handleNotifyMe()
						})
					}
				}, {
					key: "toggleNotifyMe",
					value: function(t) {
						this.notifyMeContainer && (t ? (this.notifyMeContainer.hidden = !1, this.notifySuccess.hidden = !0) : this.notifyMeContainer.hidden = !0)
					}
				}, {
					key: "handleNotifyMe",
					value: (o = a(e().m(function t() {
						var n, i, r, o, a = this;
						return e().w(function(t) {
							for (;;) switch (t.n) {
								case 0:
									if (this.notifyEmailInput) {
										t.n = 1;
										break
									}
									return t.a(2);
								case 1:
									if ((n = this.notifyEmailInput.value.trim()) && this.isValidEmail(n)) {
										t.n = 2;
										break
									}
									return alert("Please enter a valid email address"), t.a(2);
								case 2:
									if (i = this.getCurrentVariant()) {
										t.n = 3;
										break
									}
									return t.a(2);
								case 3:
									return r = window.location.pathname.split("/").pop(), o = "notify: ".concat(r, " | ").concat(i.title), t.p = 4, t.n = 5, fetch("/contact", {
										method: "POST",
										headers: {
											"Content-Type": "application/x-www-form-urlencoded"
										},
										body: new URLSearchParams({
											form_type: "contact",
											utf8: "✓",
											"contact[email]": n,
											"contact[body]": o
										})
									});
								case 5:
									t.v.ok && (this.notifySuccess.hidden = !1, this.notifyEmailInput.value = "", setTimeout(function() {
										a.notifySuccess.hidden = !0
									}, 5e3)), t.n = 7;
									break;
								case 6:
									t.p = 6, t.v, alert("Sorry, there was an error. Please try again.");
								case 7:
									return t.a(2)
							}
						}, t, this, [
							[4, 6]
						])
					})), function() {
						return o.apply(this, arguments)
					})
				}, {
					key: "isValidEmail",
					value: function(t) {
						return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t)
					}
				}, {
					key: "setupZoom",
					value: function() {
						var t, e = this;
						this.zoomTriggers.length && this.zoomOverlay && (this.zoomTriggers.forEach(function(t, n) {
							t.addEventListener("click", function(n) {
								var i = t.closest(".gmv-pdp-rhude__gallery-cell");
								if (i) {
									var r = Array.from(e.container.querySelectorAll(".gmv-pdp-rhude__gallery-cell")).indexOf(i);
									e.openZoom(r >= 0 ? r : 0)
								} else e.openZoom(0)
							})
						}), null === (t = this.zoomClose) || void 0 === t || t.addEventListener("click", function() {
							return e.closeZoom()
						}), this.zoomOverlay.addEventListener("click", function(t) {
							t.target === e.zoomOverlay && e.closeZoom()
						}), document.addEventListener("keydown", function(t) {
							e.zoomOverlay.hidden || "Escape" === t.key && e.closeZoom()
						}))
					}
				}, {
					key: "openZoom",
					value: function() {
						var t = this,
							e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0;
						this.zoomOverlay && (this.zoomOverlay.hidden = !1, this.zoomImages.forEach(function(t) {
							t.style.display = "block"
						}), document.body.style.overflow = "hidden", this.container.querySelector(".gmv-pdp-rhude__zoom-content") && this.zoomImages[e] && setTimeout(function() {
							var n = t.zoomImages[e];
							n && n.scrollIntoView({
								behavior: "instant",
								block: "start"
							})
						}, 50))
					}
				}, {
					key: "closeZoom",
					value: function() {
						this.zoomOverlay && (this.zoomOverlay.hidden = !0, document.body.style.overflow = "")
					}
				}, {
					key: "setupAccordions",
					value: function() {
						var t = this;
						this.accordionTriggers.forEach(function(e) {
							e.addEventListener("click", function() {
								return t.toggleAccordion(e)
							})
						})
					}
				}, {
					key: "toggleAccordion",
					value: function(t) {
						var e = t.nextElementSibling;
						if (e) {
							var n = "true" === t.getAttribute("aria-expanded");
							t.setAttribute("aria-expanded", !n), e.hidden = n
						}
					}
				}, {
					key: "setupSizeGuide",
					value: function() {
						var t = this;
						this.sizeGuideButtons && 0 !== this.sizeGuideButtons.length && this.sizeGuideOverlay && this.sizeGuidePopup && (this.sizeGuideButtons.forEach(function(e) {
							e.addEventListener("click", function() {
								return t.openSizeGuide()
							})
						}), this.sizeGuideClose && this.sizeGuideClose.addEventListener("click", function() {
							return t.closeSizeGuide()
						}), this.sizeGuideOverlay.addEventListener("click", function() {
							return t.closeSizeGuide()
						}), document.addEventListener("keydown", function(e) {
							"Escape" !== e.key || t.sizeGuidePopup.classList.contains("hidden") || t.closeSizeGuide()
						}))
					}
				}, {
					key: "openSizeGuide",
					value: function() {
						var t = this;
						this.sizeGuideOverlay.classList.remove("hidden"), this.sizeGuidePopup.classList.remove("hidden"), this.sizeGuideOverlay.offsetHeight, requestAnimationFrame(function() {
							t.sizeGuideOverlay.classList.add("show"), t.sizeGuidePopup.classList.add("show")
						}), document.body.style.overflow = "hidden"
					}
				}, {
					key: "closeSizeGuide",
					value: function() {
						var t = this;
						this.sizeGuideOverlay.classList.remove("show"), this.sizeGuidePopup.classList.remove("show"), setTimeout(function() {
							t.sizeGuideOverlay.classList.add("hidden"), t.sizeGuidePopup.classList.add("hidden")
						}, 300), document.body.style.overflow = ""
					}
				}, {
			key: "formatMoney",
				value: function(t) {
					var e;
					var fmt = (null === (e = window.theme) || void 0 === e ? void 0 : e.moneyFormat) || "\u20ac{{amount_with_comma_separator}}";
					if ("undefined" != typeof Shopify && Shopify.formatMoney) return Shopify.formatMoney(t, fmt);
					var n = (t / 100).toFixed(2).replace(".", ",");
					return "\u20ac" + n
				}
				}, {
					key: "setupMobileGalleryNav",
					value: function() {
						var t = this;
						if (this.gallerySlider && this.galleryPrevBtn && this.galleryNextBtn) {
							var e = this.gallerySlider.querySelectorAll(".gmv-pdp-rhude__gallery-cell"),
								n = e.length;
							if (n <= 1) {
								var i = this.container.querySelector("[data-gallery-nav]");
								i && (i.style.display = "none")
							} else this.gallerySlider.addEventListener("scroll", function() {
								var n = t.gallerySlider.scrollLeft,
									i = e[0].offsetWidth,
									r = Math.round(n / i);
								r !== t.currentSlideIndex && (t.currentSlideIndex = r, t.updateGalleryCounter(), t.updateGalleryButtons())
							}), this.galleryPrevBtn.addEventListener("click", function() {
								t.currentSlideIndex > 0 && (t.currentSlideIndex--, t.scrollToSlide(t.currentSlideIndex))
							}), this.galleryNextBtn.addEventListener("click", function() {
								t.currentSlideIndex < n - 1 && (t.currentSlideIndex++, t.scrollToSlide(t.currentSlideIndex))
							}), this.updateGalleryCounter(), this.updateGalleryButtons()
						}
					}
				}, {
					key: "scrollToSlide",
					value: function(t) {
						var e = this.gallerySlider.querySelectorAll(".gmv-pdp-rhude__gallery-cell");
						e[t] && e[t].scrollIntoView({
							behavior: "smooth",
							block: "nearest",
							inline: "start"
						})
					}
				}, {
					key: "updateGalleryCounter",
					value: function() {
						this.galleryCurrentSlide && (this.galleryCurrentSlide.textContent = this.currentSlideIndex + 1)
					}
				}, {
					key: "updateGalleryButtons",
					value: function() {
						var t = this.gallerySlider.querySelectorAll(".gmv-pdp-rhude__gallery-cell").length;
						this.galleryPrevBtn && (this.galleryPrevBtn.disabled = 0 === this.currentSlideIndex), this.galleryNextBtn && (this.galleryNextBtn.disabled = this.currentSlideIndex === t - 1)
					}
				}], n && u(t.prototype, n), r && u(t, r), Object.defineProperty(t, "prototype", {
					writable: !1
				}), t;
				var t, n, r, o, s
			}();
			"loading" === document.readyState ? document.addEventListener("DOMContentLoaded", n) : n(), "undefined" != typeof Shopify && document.addEventListener("shopify:section:load", n), window.GMV_PDP_Rhude = t
		}

		function n() {
			document.querySelectorAll(".gmv-pdp-rhude").forEach(function(e) {
				if (e.parentElement && e.parentElement.closest(".gmv-pdp-rhude")) return;
				e.dataset.initialized || (new t(e), e.dataset.initialized = "true")
			})
		}
		
		function initStickyInfo() {
			if (window.innerWidth <= 768) return;
			
			var infoSticky = document.querySelector('.gmv-pdp-rhude__info-sticky');
			var infoParent = document.querySelector('.gmv-pdp-rhude__info');
			var gallery = document.querySelector('.gmv-pdp-rhude__gallery');
			
			if (!infoSticky || !infoParent || !gallery) return;
			
			var stickyTop = 87;
			var stickyWidth = 0;
			var stickyLeft = 0;
			var originalOffsetTop = 0;
			
			function calculatePositions() {
				var parentRect = infoParent.getBoundingClientRect();
				stickyWidth = parentRect.width;
				stickyLeft = parentRect.left + window.pageXOffset;
				originalOffsetTop = infoParent.offsetTop;
			}
			
			function checkSticky() {
				if (window.innerWidth <= 768) {
					infoSticky.classList.remove('is-stuck', 'is-bottom');
					infoSticky.style.width = '';
					infoSticky.style.left = '';
					infoSticky.style.top = '';
					infoSticky.style.position = '';
					return;
				}
				
				calculatePositions();
				
				var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
				var infoHeight = infoSticky.offsetHeight;
				var galleryBottom = gallery.offsetTop + gallery.offsetHeight;
				var panelBottom = scrollTop + stickyTop + infoHeight;
				
				if (scrollTop + stickyTop >= originalOffsetTop) {
					if (panelBottom <= galleryBottom) {
						infoSticky.classList.add('is-stuck');
						infoSticky.classList.remove('is-bottom');
						infoSticky.style.position = 'fixed';
						infoSticky.style.width = stickyWidth + 'px';
						infoSticky.style.left = stickyLeft + 'px';
						infoSticky.style.top = stickyTop + 'px';
					} else {
						infoSticky.classList.remove('is-stuck');
						infoSticky.classList.add('is-bottom');
						var maxTop = galleryBottom - infoHeight - originalOffsetTop;
						infoSticky.style.position = 'absolute';
						infoSticky.style.width = '';
						infoSticky.style.left = '';
						infoSticky.style.top = maxTop + 'px';
					}
				} else {
					infoSticky.classList.remove('is-stuck', 'is-bottom');
					infoSticky.style.position = '';
					infoSticky.style.width = '';
					infoSticky.style.left = '';
					infoSticky.style.top = '';
				}
			}
			
			var scrollTimeout;
			function handleScroll() {
				if (scrollTimeout) {
					window.cancelAnimationFrame(scrollTimeout);
				}
				scrollTimeout = window.requestAnimationFrame(checkSticky);
			}
			
			window.addEventListener('scroll', handleScroll, { passive: true });
			window.addEventListener('resize', function() {
				calculatePositions();
				checkSticky();
			});
			
			calculatePositions();
			checkSticky();
		}
		
		if ('loading' === document.readyState) {
			document.addEventListener('DOMContentLoaded', function() {
				n();
				initStickyInfo();
			});
		} else {
			n();
			initStickyInfo();
		}
	}()
	
	// PROMO DISCOUNT - Logic moved directly into updatePrice method above
	
	// CURRENCY CONVERSION FEATURES DISABLED - All functions commented out
	/* DISABLED
	window.checkAndToggleOriginalPriceRhude=function(){var e=document.querySelector(".gmv-pdp-rhude [data-price]"),t=document.querySelector(".gmv-pdp-rhude [data-original-price]");if(e&&t){var n=e.textContent.trim(),r=e.getAttribute("data-currency")||"EUR",o=n.replace(/[\d.,\s]/g,"").trim(),a={EUR:"€",USD:"$",GBP:"£",JPY:"¥",CAD:"CA$",AUD:"A$",IDR:"Rp"}[r]||"€";console.log("Rhude Currency check - Current Symbol:",o,"Shop Symbol:",a,"Shop Currency:",r),o!==a?t.style.display="flex":t.style.display="none"}},window.openConversionModalRhude=function(){var e=document.getElementById("conversion-modal-rhude");e&&(e.classList.add("active"),e.style.display="flex",document.body.style.overflow="hidden")},window.closeConversionModalRhude=function(){var e=document.getElementById("conversion-modal-rhude");e&&(e.classList.remove("active"),e.style.display="none",document.body.style.overflow="")},window.addEventListener("click",function(e){"conversion-modal-rhude"===e.target.id&&window.closeConversionModalRhude()}),"loading"===document.readyState?document.addEventListener("DOMContentLoaded",function(){setTimeout(window.checkAndToggleOriginalPriceRhude,100),setTimeout(window.checkAndToggleOriginalPriceRhude,500),setTimeout(window.checkAndToggleOriginalPriceRhude,1e3)}):(setTimeout(window.checkAndToggleOriginalPriceRhude,100),setTimeout(window.checkAndToggleOriginalPriceRhude,500),setTimeout(window.checkAndToggleOriginalPriceRhude,1e3));var priceObserverGlobal=new MutationObserver(function(){setTimeout(window.checkAndToggleOriginalPriceRhude,100)}),priceElementGlobal=document.querySelector(".gmv-pdp-rhude [data-price]");priceElementGlobal&&priceObserverGlobal.observe(priceElementGlobal,{childList:!0,subtree:!0,characterData:!0});var originalPriceValueGlobal=document.querySelector(".gmv-pdp-rhude__price-original-value");if(originalPriceValueGlobal){var originalTextGlobal=originalPriceValueGlobal.textContent,originalPriceObserverGlobal=new MutationObserver(function(){var e=originalPriceValueGlobal.textContent;e!==originalTextGlobal&&originalTextGlobal&&(originalPriceValueGlobal.textContent=originalTextGlobal)});originalPriceObserverGlobal.observe(originalPriceValueGlobal,{childList:!0,subtree:!0,characterData:!0}),window.setOriginalPriceValueRhude=function(e){originalTextGlobal=e,originalPriceValueGlobal.textContent=e}}
	*/
})();